import React from 'react';
interface LogoProps {
  size?: number;
  className?: string;
}
// Just the icon mark (circular palm icon only)
export function LogoMark({
  size = 32,
  className = ''
}: LogoProps) {
  return <img src="https://cdn.magicpatterns.com/uploads/qNW3eTRNduSkijRFpRPJbo/logo-sawit-net-FIX.png" alt="sawit-net" className={`flex-shrink-0 object-contain ${className}`} style={{
    width: size,
    height: size
  }} data-id="element-217" />;
}
interface LogoFullProps {
  size?: number;
  showTagline?: boolean;
  dark?: boolean;
}
// Full logo — icon + wordmark (all in one image)
export function LogoFull({
  size = 32
}: LogoFullProps) {
  return <img src="https://cdn.magicpatterns.com/uploads/qNW3eTRNduSkijRFpRPJbo/logo-sawit-net-FIX.png" alt="sawit-net" className="flex-shrink-0 object-contain" style={{
    height: size,
    width: 'auto'
  }} data-id="element-218" />;
}